<template>
  <div>
    <div :class="['div-input']">
      <div class="input-custom">
        <label v-if="textFloat">
          {{ textFloat }}<span v-if="isRequired" class="text-danger">*</span>
        </label>
        <div class="d-flex align-items-center">
          <input
            type="color"
            id="head"
            :ref="name"
            :name="name"
            :value="value"
            @input="$emit('input', $event.target.value)"
          />
          <div class="color-select" @click="toggleColorPicker()">
            <label class="mb-0">{{ value || "Select Color" }}</label>
          </div>
        </div>
        <div v-if="v && v.$error">
          <span class="text-error" v-if="v.required == false">กรุณากรอกข้อมูล</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    textFloat: {
      required: false,
      type: String,
    },
    value: {
      required: false,
      type: String,
    },
    name: {
      required: false,
      type: String,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
    v: {
      required: false,
      type: Object,
    }
  },
  methods: {
    toggleColorPicker() {
      this.$refs[this.name].click();
    },
  },
};
</script>

<style>
.div-input {
  margin-bottom: 15px;
  position: relative;
  white-space: nowrap;
}
.input-custom > label {
  color: #404040;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}
.color-select {
  /* border: 1px solid #ccc; */
  background-color: white;
  border: 1px solid #4f4f4f;
  border-radius: 2px;
  padding: 3px 13px;
  height: 35px;
  display: flex;
  align-items: center;
  min-width: 100px;
  white-space: nowrap;
  margin-left: -3px;
  z-index: 1;
  border-left: none;
}
input[type="color"] {
  z-index: 2;
  height: 35px;
  /* border-radius: unset; */
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  border-color: #4f4f4f;
}
</style>
